/**
 * @public
 */
export type CharacterOrderType = 'ltr' | 'rtl';

/**
 * @public
 */
export type ContextType = 'middle-of-text' | 'begin-sentence' | 'standalone' | 'ui-list-or-menu';

/**
 * @public
 */
export type LineOrderType = 'ttb' | 'btt';

/**
 * @public
 */
export type ListPatternPositionType = 'start' | 'middle' | 'end' | 'two';
